// ─── Permission groups ────────────────────────────────────────────────────
// كل الثوابت هنا عشان App.js يفضل نضيف، وأي تعديل في الصلاحيات يبقى من مكان واحد.

export const ALL_VIEW_PERMS = [
  "Construction.View", "Emergency.View", "Maintenance.View",
  "NewProject.View", "PrivateProject.View", "Attendance.View",
  "LeaveRequest.View", "Custody.View", "Employees.View",
  "Branch.View", "Office.View", "Neighborhood.View",
  "Consultant.View", "Contractor.View", "WorkOrderType.View",
  "JobDescription.View", "Notifications.View", "Users.View",
];

export const PROJECT_VIEW_PERMS = [
  "Construction.View", "Emergency.View",
  "Maintenance.View", "NewProject.View", "PrivateProject.View",
];

export const PROJECT_UPDATE_PERMS = [
  "Construction.Update", "Emergency.Update",
  "Maintenance.Update", "NewProject.Update", "PrivateProject.Update",
];

/** التحديث اليومي: تعديل أمر العمل أو صلاحية «تسجيل تنفيذ» المستقلة. */
export const DAILY_EXECUTION_PERMS = [
  ...PROJECT_UPDATE_PERMS,
  "Construction.Execute", "Emergency.Execute", "Maintenance.Execute",
];

export const ALL_APPROVE_PERMS = [
  "Construction.Approve", "Emergency.Approve",
  "Maintenance.Approve", "NewProject.Approve", "PrivateProject.Approve",
];

export const ALL_DELETE_PERMS = [
  "Construction.Delete", "Emergency.Delete",
  "Maintenance.Delete", "NewProject.Delete", "PrivateProject.Delete",
];

// ─── User types ───────────────────────────────────────────────────────────
export const USER_TYPES = {
  ADMIN: "admin",
  SUPERVISOR: "supervisor",
  OFFICE_MANAGER: "officeManager",
  ENG: "eng",
  CONTRACTOR: "contractor",
};

export const ADMIN_LAYOUT_TYPES = [
  USER_TYPES.ADMIN,
  USER_TYPES.SUPERVISOR,
  USER_TYPES.OFFICE_MANAGER,
];

export const NAVBAR_USER_TYPES = [USER_TYPES.ENG, USER_TYPES.CONTRACTOR];

// ─── Fallback when the user lacks permission ──────────────────────────────
export function getFallback(userType) {
  switch (userType) {
    case USER_TYPES.ENG:
      return "/main-page";
    case USER_TYPES.CONTRACTOR:
      return "/projects";
    // supervisor / officeManager → مفيش داشبورد ليهم، يرجعوا للـ login
    // أو أول صفحة عندهم صلاحية عليها (بيتحدد بعد كده من الـ Sidebar)
    default:
      return "/";
  }
}